/**
 * Onboarding API client — Task #23
 */

import apiClient from './apiClient';
import type {
  CompleteOnboardingPayload,
  CompleteOnboardingResult,
  OnboardingPatch,
  OnboardingState,
} from '../types/onboarding';

export async function getOnboardingState(): Promise<OnboardingState> {
  const response = await apiClient.get<OnboardingState>('/api/onboarding');
  return response.data;
}

export async function patchOnboarding(patch: OnboardingPatch): Promise<OnboardingState> {
  const response = await apiClient.patch<OnboardingState>('/api/onboarding', patch);
  return response.data;
}

export async function completeOnboarding(
  payload: CompleteOnboardingPayload = {},
): Promise<CompleteOnboardingResult> {
  const response = await apiClient.post<CompleteOnboardingResult>(
    '/api/onboarding/complete',
    payload,
  );
  return response.data;
}
